import {PureComponent} from "react";
import ContentWrapper from 'Component/ContentWrapper';
import CmsBlock from 'Component/CmsBlock';
import AlphabeticBrandList from '../../component/AlphabeticBrandList';
import NumericBrandList from '../../component/NumericBrandList';
import Link from 'SourceComponent/Link';
import Html from 'SourceComponent/Html';
import Image from 'SourceComponent/Image';
import SlickSlider from 'Component/SlickSlider';
import history from 'Util/History';
import media from 'SourceUtil/Media/Media';
import StickyBox from "react-sticky-box";

import './BrandListPage.style';
import PropTypes from "prop-types";
const nonAlphabets = [
        '0','1','2','3',
        '4','5','6','7',
        '8','9'
               ];
const alphabets = [
    'A','B','C','D','E','F','G','H',
    'I','J','K','L','M','N',
    'O','P','Q','R','S','T',
    'U','V','W','X','Y','Z'
];

const greekAlphabets = [
    "Α", "Β", "Γ", "Δ", "Ε", "Ζ", "Η", "Θ",
    "Ι", "Κ", "Λ", "Μ", "Ν", "Ξ", "Ο", "Π",
    "Ρ", "Σ", "Τ", "Υ", "Φ", "Χ", "Ψ", "Ω"
];


/** @namespace Route/BrandListPage/Component */
export class BrandListPage  extends PureComponent {
    static propTypes = {
        onTabClick: PropTypes.func.isRequired,
        selectedMenuIndex: PropTypes.string.isRequired
    };

    componentDidMount() {
        window.addEventListener('scroll', () => {
            this.updateBrandFilterStyle();
        });
    }

    updateBrandFilterStyle() {
        let header = document.getElementById('Header');
        let headerSlogan = document.getElementById('HeaderSlogan');
        let headerTopMenu = document.getElementById('Header-TopMenu');
        let brandsPageFilters = document.getElementById('BrandsPage-filters');
        let st = window.pageYOffset || document.documentElement.scrollTop;
        let HeaderHeight = 0;
        let headerSloganHeight = 0;
        let headerTopMenuHeight = 0;
        let headerScrollTop = 0;

        if(headerSlogan) {
            headerSloganHeight = headerSlogan.clientHeight;
        }

        if(headerTopMenu) {
            headerTopMenuHeight = headerTopMenu.clientHeight;
        }

        if(header) {
            HeaderHeight = header.clientHeight;
        }

        if(window.scrollY > HeaderHeight) {
            headerScrollTop = headerSloganHeight + headerTopMenuHeight;
        } else {
            headerScrollTop = 0
        }

        if(brandsPageFilters) {
            brandsPageFilters.style.top = (HeaderHeight - headerScrollTop) + 'px';
        }
    }

    handleClick (id) {
        let brandsPageFilters = document.getElementById('BrandsPage-filters');
        let targetId = document.getElementById(this);
        let targetIdOffsetTop = targetId.getBoundingClientRect().top + window.pageYOffset - brandsPageFilters.clientHeight - 230;

        if(targetId){
            window.scrollTo({top: targetIdOffsetTop, behavior: 'smooth'});
        }
    }

    renderNonAlphabetics(){
        const { filteredBrandsList } = this.props;

        if(filteredBrandsList.filter(list => list.title.charAt(0) === nonAlphabets).length < 1) {
            return null;
        }

        return (
            <div id="nonAlphabets" className="BrandsPage-listchunk">
              <h4 className="BrandsPage-title">#</h4>
                <NumericBrandList
                    nonAlphabets={nonAlphabets}
                    brandList={filteredBrandsList}
                />
            </div>
        )
    }

    renderAlphabetsAndItems = (alphabet) => {
        const { filteredBrandsList } = this.props;

        if(filteredBrandsList.filter(list => list.title.charAt(0) === alphabet).length < 1) {
            return null;
        }

        return (
            <div id={alphabet} className="BrandsPage-listchunk">
                <h4 className="BrandsPage-title">{alphabet}</h4>
                <AlphabeticBrandList
                    alphabet={alphabet}
                    brandList={filteredBrandsList}
                />
            </div>
        )
    }

    renderNonAlphabets = (nonAlphabets) => {
        const { filteredBrandsList } = this.props;

        if(filteredBrandsList.filter(list => list.title.charAt(0) === nonAlphabets).length < 1) {
            return (
                <h5 className="BrandsPage-alphabets inactive">#</h5>
            )
        }

        return (
            <h5 className="BrandsPage-alphabets" onClick={this.handleClick.bind('nonAlphabets')}>#</h5>
        )
    }

    renderAlphabets = (alphabet) => {
        const { filteredBrandsList } = this.props;

        if(filteredBrandsList.filter(list => list.title.charAt(0) === alphabet).length < 1) {
            return (
                <h5 className="BrandsPage-alphabets inactive">{alphabet}</h5>
            )
        }

        return (
            <h5 className="BrandsPage-alphabets" onClick={this.handleClick.bind(alphabet)}>{alphabet}</h5>
        )
    }
    renderOtherAlphabets = (alphabet) => {
        const { filteredBrandsList } = this.props;

        if(filteredBrandsList.filter(list => !alphabets.includes(list.title.charAt(0))).length !== 0) {
            return (
                <h5 className="BrandsPage-alphabets" onClick={this.handleClick.bind('Z')}>Α<br/>-<br/>Ω</h5>
            )
        }
        return (
            <h5 className="BrandsPage-alphabets inactive">Α<br/>-<br/>Ω</h5>
        )
    }

    renderAlphabetsList(){
        const { brandList, device } = this.props;

        if (brandList && brandList.length < 1){
            return ;
        }

        if(device.isMobile) {
            return(
                <div>
                    <StickyBox offsetTop={159} offsetBottom={0}>
                        <div className="BrandsPage-alphabets_list">
                            {
                                this.renderNonAlphabets()
                            }
                            {
                                alphabets.map(this.renderAlphabets)
                            }
                            {
                                this.renderOtherAlphabets()
                            }
                        </div>
                    </StickyBox>
                </div>
            )
        }

        return(
            <div className="BrandsPage-alphabets_list_container">
                <div className="BrandsPage-alphabets_list_wrapper">
                    <div className="BrandsPage-alphabets_list">
                        {
                            this.renderNonAlphabets()
                        }
                        {
                            alphabets.map(this.renderAlphabets)
                        }
                        {
                            this.renderOtherAlphabets()
                        }
                    </div>
                </div>
            </div>
        )
    }

    renderImage = (brand, i) => {
        const {
            imagePlaceholder
        } = this.props;

        const {
            option_setting_id: brandId,
            small_image_alt: alt,
            slider_image: sliderImg,
            title: label,
            url_alias: url
        } = brand;
        let src = '';

        if(sliderImg){
            src = media(sliderImg,'amasty/shopby/option_images/slider/');
        }else {
            src = media(imagePlaceholder, 'amasty/shopby/placeholder/');
        }

        return (
            <figure
                block="SliderWidget"
                elem="Figure"
                key={i}
                id={brandId}
            >
                <Link to={url}>
                    <Image
                        mix={{ block: 'SliderWidget', elem: 'FigureImage' }}
                        ratio="custom"
                        alt="alt"
                        src={src}
                        isPlaceholder={!src ? true : false}
                    />
                    <figcaption
                        block="SliderWidget"
                        elem="Figcaption"
                        mix={{ alt }}
                    >
                        <Html content={label || ''} />
                    </figcaption>
                </Link>
            </figure>
        );
    };

    renderStoreBrandAttribute = (item) => {
        return (
            <Link to={item.label}>
                { item.label }
            </Link>
        );
    };

    renderHeroBrandList(){
        const { featuredBrands } = this.props;

        if (featuredBrands && featuredBrands.length === 0){
            return null;
        }

        const setting = {
            slides_to_display: 10,
            slides_to_scroll: 1,
            slides_to_display_mobile: 3,
            show_navigation: true
        };

        return(
            <div className="BrandWidget-Main">
                <h2 className="BrandWidget-Main_title">{ __('Top Brands') }</h2>
                <SlickSlider
                    { ...setting }
                    slick_slider_class="ProductLinks-Slider">
                    {featuredBrands.map(this.renderImage)}
                </SlickSlider>
            </div>
        )
    }

    renderStoreBrandAttributeList(){
        const { brand_type_options, onTabClick, selectedMenuIndex } = this.props;

        if (brand_type_options && brand_type_options.length === 0){
            return null;
        }

        return(
            <div className="BrandsPage-brand_attributes" id="BrandsPage-brand_attributes">
                {brand_type_options.map((index,brand_type_option) => {

                    return  (
                        <div
                        key={brand_type_option}
                        className={"BrandsPage-brand_attribute " + (brand_type_options[brand_type_option].value == selectedMenuIndex ? "active": "") }
                        onClick={ () => onTabClick(brand_type_options[brand_type_option].value) }>
                        { brand_type_options[brand_type_option].label }
                    </div>
                    );
                })}
            </div>

        )
    }

    renderBrandList(){
        const { filteredBrandsList } = this.props;
        let brand_type_filtered = [];

        if (filteredBrandsList && filteredBrandsList.length === 0){
            return null;
        }

        return(
            <>
                {
                    this.renderNonAlphabetics()
                }
                {
                    alphabets.map(this.renderAlphabetsAndItems)
                }
                {
                    greekAlphabets.map(this.renderAlphabetsAndItems)
                }
            </>

        )
    }

    renderBrandHeading(){
        const { brandList } = this.props;

        if (brandList && brandList.length < 1){
            return <h1 className="BrandsPage-maintitle">{ __('BRANDS') }</h1>;
        }

        return (
            <h1 className="BrandsPage-maintitle">
                { __('BRANDS') }
                <span>{ __('(%s)', brandList.length) }</span>
            </h1>
        );
    }

    renderBrandDescription(){
        const { attribute_code } = this.props;

        if(!attribute_code) {
            return null;
        }

        return (
            <div className="BrandsPage-maindescription">
                <CmsBlock identifier={ attribute_code+'_page_description' } />
            </div>
        );
    }

    render() {
        const { device } = this.props;

        return(
            <main block="BrandsPage" aria-label="Brands Page">
                <ContentWrapper
                    wrapperMix={ { block: 'BrandsPage', elem: 'Wrapper' } }
                    label="Cart page details"
                >
                    { this.renderBrandHeading() }
                    { this.renderBrandDescription() }
                    { this.renderHeroBrandList() }
                    <div className="BrandsPage-filters" id="BrandsPage-filters">
                        { this.renderStoreBrandAttributeList() }
                        { device.isMobile ? null : this.renderAlphabetsList() }
                    </div>
                    <div className="BrandsPage-list_container" id="BrandsPage-list_container">
                        { device.isMobile ? this.renderAlphabetsList() : null }
                        <div className="BrandsPage-list">
                            { this.renderBrandList() }
                        </div>
                    </div>
                </ContentWrapper>
            </main>
        );
    }
}
export default BrandListPage;
